<template>
  <div class="setting-content">
    <div v-for="(list,index) in menu" :key="index" class="page-card-item">
      <div @click="$router.push({path:'/'+list.href})" style="height: 100%">
        <label class="top"></label>
        <label :class="['bottom', $i18n.locale === 'en' ? 'en-fontSize' : '']"><span>{{ $t(list.menuCode) }}</span></label>
      </div>
    </div>
  </div>
</template>
<script>
    import {mapGetters} from 'vuex'

    export default {
        name: 'system',
        data() {
            return {
                colorList: ['#00338d', '#1797d4', '#6d2077', '#00a3a1', '#00c0ae'],
                cardBgList: ['cardBg1', 'cardBg2', 'cardBg3', 'cardBg4', 'cardBg5'],
                menu: []
            }
        },
        computed: {
            ...mapGetters('common', {
                getUser: 'getUser',
                getCurrentMenu: 'getCurrentMenu'
            })
        },
        mounted() {
            this.getCurrentMenu.forEach(i => {
                if (i.href === 'system') {
                    this.menu = i.childMenuList
                }
            })
        }
    }
</script>
<style scoped>
  .setting-content {
    padding: 22px;
    overflow-y: auto;
    margin: 0px !important;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-wrap: wrap;
  }
  .page-card-item{
    margin-right: 30px;
    margin-bottom: 30px;
    width: calc((100% - 120px) / 5);
    height: 225px;
    background-color: #fff;
    border-radius: 4PX 4PX 8PX 8PX;
  }
  .page-card-item:nth-child(5n){
    margin-right: 0;
  }
  .page-card-item:hover {
    border-radius: 4PX 4PX 8PX 8PX;
    border: 1PX solid #3879EB;
    box-shadow: 0 0 15px rgba(56,121,235,0.4);
  }

  .page-card-item label {
    width: 100%;
    display: block;
    font-family: 'KPMG Light', 'KPMG';
    font-weight: 300;
    font-style: normal;
    font-size: 40px;
    text-align: center;
    line-height: 48px;
    cursor: pointer;
  }
  .page-card-item label.en-fontSize{
    font-size: 54px;
    line-height: 62px;
  }
  .page-card-item .top {
    height: 12px;
    background-color: #3879EB;
    border-radius: 4PX 4PX 0 0;
  }

  .page-card-item .bottom {
    display: flex;
    justify-content: center;
    align-items: center;
    height: calc(100% - 12px);
    color: #00338D;
    padding: 0 5PX;
  }

  .page-card-item .bottom span {
    display: inline-block;
    width: 90%;
  }
</style>
